<template>
  <div id="app">
    <div class="nav">
      <p><router-link to="/">首页</router-link></p>
      <p><router-link to="/Programme">方案中心</router-link></p>
      <p><router-link to="/customer">客户案例</router-link></p>
      <p><router-link to="/intelligence">智能设备</router-link></p>
      <p><router-link to="/psychology">心理咨询</router-link></p>
      <p><router-link to="/my">关于我们</router-link></p>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
#app {
  .nav {
    display: flex;
    z-index: 1000;
    height: 50px;
    // width: 600px;
    // background-color: pink;
    position: absolute;
    top: 10px;
    left: 500px;
    p {
      margin-left: 60px;
      font-weight:700;
    }
    a {
      color: #fff;
    }
    a:hover {
      border-bottom: 2px solid #fff;
    }
  }
}
</style>
